/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_No_CarriersInputs */

const en_carrier_notices_no_carriers = /** @type {(inputs: Carrier_Notices_No_CarriersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No carriers found.`)
};

const es_carrier_notices_no_carriers = /** @type {(inputs: Carrier_Notices_No_CarriersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron transportistas.`)
};

/**
* | output |
* | --- |
* | "No carriers found." |
*
* @param {Carrier_Notices_No_CarriersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_no_carriers = /** @type {((inputs?: Carrier_Notices_No_CarriersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_No_CarriersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_no_carriers(inputs)
	return es_carrier_notices_no_carriers(inputs)
});